const langAdminDocumentAccess = {
	title: {
		tag: 'admin.document_access.title',
		fr: 'Logs des accès aux documents',
		en: 'Document access logs',
	},
	filter_start_download_date: {
		tag: 'admin.document_access.filter_start_download_date',
		fr: 'Date mini du téléchargement',
		en: 'Start download date',
	},
	filter_end_download_date: {
		tag: 'admin.document_access.filter_end_download_date',
		fr: 'Date max du téléchargement',
		en: 'End download date',
	},
	filter_keywords: {
		tag: 'admin.document_access.filter_keywords',
		fr: 'Mots clés',
		en: 'Keywords',
	},
	filter_funds: {
		tag: 'admin.document_access.filter_funds',
		fr: 'Fonds',
		en: 'Funds',
	},
	filter_groups: {
		tag: 'admin.document_access.filter_groups',
		fr: 'Groupes',
		en: 'Groups',
	},
	filter_type: {
		tag: 'admin.document_access.filter_type',
		fr: 'Type',
		en: 'Type',
	},
	filter_expertise: {
		tag: 'admin.document_access.expertise',
		fr: 'Expertise',
		en: 'Expertise',
	},
	filter_start_released_date: {
		tag: 'admin.document_access.filter_start_released_date',
		fr: 'Date de sortie mini',
		en: 'Start release date',
	},
	filter_end_released_date: {
		tag: 'admin.document_access.filter_end_released_date',
		fr: 'Date de sortie maxi',
		en: 'End release date',
	},
	btn_export_excel: {
		tag: 'admin.document_access.btn_export_excel',
		fr: 'Export en XLSX',
		en: 'Export XLSX',
	},
	hide_employee_access: {
		tag: 'admin.document_access.hide_employee_access',
		fr: 'Cacher les accès employés',
		en: 'Hide employees access',
	},
};

export default langAdminDocumentAccess;
